import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClienteComboOutput } from 'src/app/@shared/models/consulta-detalhe';

@Injectable({
  providedIn: 'root'
})
export class StatusParaSfxService {

  constructor(private http: HttpClient) { }

  public getClientesAtivos(): Observable<ClienteComboOutput[]> {
    return this.http.get<ClienteComboOutput[]>(
      `IntegracaoNotFis/ListarClientesAtivos`
    );
  }

  public cadastrarStatusSFX(data): Observable<any> {
    return this.http.post<any>('IntegracaoSfx/enviarUltimoStatus', data)
  }
}
